import { OPERATIONS } from "pages/AddWorker/config";
import publicIp from "public-ip";
import {
  browserName,
  osName,
  deviceType,
  fullBrowserVersion,
} from "react-device-detect";
import { EventEmitter } from "utils/EventEmitter";

EventEmitter.subscribe("versionChange", (version) => {
  DEVICE_DETAILS.appVersion = version;
  console.log("Version change", DEVICE_DETAILS);
});

export const getClientIp = async () =>
  await publicIp.v4({
    fallbackUrls: ["https://ifconfig.co/ip"],
  });

export const appVersion = "1.40.0";

export const getDeviceType = (value) => {
  switch (value) {
    case "browser":
      return "Desktop Web Browser";

    default:
      return value;
  }
};

export const DEVICE_DETAILS = {
  ip: null,
  OS: osName,
  browser: browserName + " " + fullBrowserVersion,
  displayResolution: window.screen.width + "*" + window.screen.height,
  deviceType: getDeviceType(deviceType),
  appVersion: appVersion,
};

try {
  getClientIp()
    .then((data) => (DEVICE_DETAILS.ip = data))
    .catch((e) => {
      console.log("error in fetching IP", e);
    });
} catch (e) {
  console.log("error in fetching IP");
}

export const LOCATIONS = [
  {
    value: "AE",
    label: "AE-Seville",
    buildings: [
      { value: "AE02", label: "AE02-Seville" },
      { value: "AES0", label: "AES0-Seville Shred Plant" },
      { value: "AEZ1", label: "AEZ1-AE VIRTUAL DESTRUCTION BULDING" },
    ],
  },
  {
    value: "AS",
    label: "AS-Aberdeen",
    buildings: [
      { value: "ASCR", label: "ASCR-CROMBIE ROAD" },
      { value: "ASDY", label: "ASDY-Aberdeen - Dyce" },
      { value: "ASER", label: "ASER-ERROR BUILDING" },
      { value: "ASK2", label: "ASK2-KIRKHILL 2" },
      { value: "ASKH", label: "ASKH-KIRKHILL" },
      { value: "ASS0", label: "ASS0-Aberdeen Shred Plant" },
      { value: "ASSA", label: "ASSA-SAUCHEN" },
      { value: "ASWH", label: "ASWH-WELLHEADS" },
      { value: "ASZ1", label: "ASZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "AV",
    label: "AV-Vienna",
    buildings: [
      { value: "AV03", label: "AV03-Vienna" },
      { value: "AVIC", label: "AVIC-Vienna" },
      { value: "AVS0", label: "AVS0-Vienna Shred Plant" },
    ],
  },
  {
    value: "BB",
    label: "BB-Belgium",
    buildings: [
      { value: "BBDI", label: "BBDI-Diegem" },
      { value: "BBDU", label: "BBDU-Duffel" },
      { value: "BBGR", label: "BBGR-Grimbergen" },
      { value: "BBIC", label: "BBIC-Grimbergen" },
      { value: "BBS0", label: "BBS0-Belgium Shred Plant" },
      { value: "BBSE", label: "BBSE-Seneffe" },
      { value: "BBZ1", label: "BBZ1-BB Virtual Destruction Building" },
    ],
  },
  {
    value: "BE",
    label: "BE-Bilbao",
    buildings: [
      { value: "BEGK", label: "BEGK-Bilbao" },
      { value: "BEIC", label: "BEIC-Bilbao" },
      { value: "BES0", label: "BES0-Bilbao Shred Plant" },
      { value: "BEZ1", label: "BEZ1-BE VIRTUAL DESTRUCTION BUILDING" },
    ],
  },
  {
    value: "CE",
    label: "CE-Barcelona",
    buildings: [
      { value: "CE01", label: "CE01-Barcelona" },
      { value: "CE02", label: "CE02-Barcelona - Llinars" },
      { value: "CEF1", label: "CEF1-Barcelona" },
      { value: "CEIC", label: "CEIC-Barcelona" },
      { value: "CES0", label: "CES0-Barcelona Shred Plant" },
      { value: "CEWE", label: "CEWE-TARRAGONA 1" },
      { value: "CEWF", label: "CEWF-TARRAGONA 2" },
      { value: "CEWG", label: "CEWG-TARRAGONA 3" },
      { value: "CEWH", label: "CEWH-CASTELLVI" },
      { value: "CEWI", label: "CEWI-CASTELLVI 3" },
      { value: "CEWK", label: "CEWK-CASTELLVI 2" },
      { value: "CEXE", label: "CEXE-TARRAGONA 4" },
      { value: "CEZ1", label: "CEZ1-CE VIRTUAL DESTRUCTION BUILDING" },
    ],
  },
  {
    value: "CZ",
    label: "CZ-Czech Republic",
    buildings: [
      { value: "CZ01", label: "CZ01-Jenec" },
      { value: "CZ02", label: "CZ02-Jenec" },
      { value: "CZ03", label: "CZ03-Jenec" },
      { value: "CZ04", label: "CZ04-Prague" },
      { value: "CZ05", label: "CZ05-Prague" },
      { value: "CZS0", label: "CZS0-Czech Republic Shred Plant" },
    ],
  },
  {
    value: "DB",
    label: "DB-Damsdorf",
    buildings: [
      { value: "DBDA", label: "DBDA-Damsdorf" },
      { value: "DBS0", label: "DBS0-Damsdorf Shred Plant" },
      { value: "DBVP", label: "DBVP-Lipzig" },
      { value: "DBZ1", label: "DBZ1-DB Virtual Destruction Building" },
    ],
  },
  {
    value: "DC",
    label: "DC-Bochum",
    buildings: [
      { value: "DCHH", label: "DCHH-Bochum" },
      { value: "DCS0", label: "DCS0-Bochum Shred Plant" },
      { value: "DCYD", label: "DCYD-Hilden" },
      { value: "DCZ1", label: "DCZ1-DC Virtual Destruction Building" },
    ],
  },
  {
    value: "DF",
    label: "DF-Butzbach",
    buildings: [
      { value: "DFBU", label: "DFBU-Butzbach" },
      { value: "DFHF", label: "DFHF-Hofheim" },
      { value: "DFS0", label: "DFS0-Butzbach Shred Plant" },
      { value: "DFZ1", label: "DFZ1-DF Virtual Destruction Building" },
    ],
  },
  {
    value: "DH",
    label: "DH-Hamburg",
    buildings: [
      { value: "DHBK", label: "DHBK-Hamburg Bunker" },
      { value: "DHHD", label: "DHHD-Hamburg - Scanning" },
      { value: "DHRA", label: "DHRA-Hamburg" },
      { value: "DHS0", label: "DHS0-Hamburg Shred Plant" },
      { value: "DHVK", label: "DHVK-Hamburg Recall" },
      { value: "DHZ1", label: "DHZ1-DH Virtual Destruction Building" },
    ],
  },
  {
    value: "DM",
    label: "DM-Markt Schwaben",
    buildings: [
      { value: "DMFB", label: "DMFB-Fuerstenfeldbruck" },
      { value: "DMMS", label: "DMMS-Markt Schwaben" },
      { value: "DMS0", label: "DMS0-Markt Schwaben Shred Plant" },
      { value: "DMZ1", label: "DMZ1-DM Virtual Destruction Building" },
    ],
  },
  {
    value: "DW",
    label: "DW-Wipshausen",
    buildings: [
      { value: "DWBW", label: "DWBW-Wipshausen" },
      { value: "DWS0", label: "DWS0-Wipshausen Shred Plant" },
      { value: "DWZ1", label: "DWZ1-DW Virtual Destruction Building" },
      { value: "E S0", label: "E S0-Plus Euro Corporate Shred Plant" },
      { value: "E Z1", label: "E Z1-IB VIRTUAL DESTRUCTION BUILDING" },
    ],
  },
  { value: "E", label: "E-Plus Euro Corporate", buildings: [] },
  {
    value: "EE",
    label: "EE-Sittingbourne",
    buildings: [
      { value: "EEER", label: "EEER-ERROR BUILDING" },
      { value: "EES0", label: "EES0-Sittingbourne Shred Plant" },
      { value: "EES1", label: "EES1-BUILDING S1" },
      { value: "EES7", label: "EES7-BUILDING 7" },
      { value: "EEWH", label: "EEWH-WHITE HART TRIANGLE" },
      { value: "EEZ1", label: "EEZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "EJ",
    label: "EJ-Jersey",
    buildings: [{ value: "EJZ1", label: "EJZ1-VIRTUAL DESTRUCTION BUILDING" }],
  },
  {
    value: "EK",
    label: "EK-Kemble",
    buildings: [
      { value: "EK01", label: "EK01-GL KEMBLE" },
      { value: "EK02", label: "EK02-GL KEMBLE" },
      { value: "EK03", label: "EK03-GL KEMBLE" },
      { value: "EK04", label: "EK04-GL KEMBLE" },
      { value: "EKA1", label: "EKA1-GL KEMBLE" },
      { value: "EKB2", label: "EKB2-BS BARTON HILL" },
      { value: "EKD1", label: "EKD1-GL KEMBLE" },
      { value: "EKF1", label: "EKF1-BS FISHPONDS" },
      { value: "EKF2", label: "EKF2-BS FISHPONDS" },
      { value: "EKKI", label: "EKKI-GL KEMBLE" },
      { value: "EKS0", label: "EKS0-Kemble Shred Plant" },
      { value: "EKZ1", label: "EKZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "EL",
    label: "EL-London",
    buildings: [
      { value: "EL1F", label: "EL1F-London - Cody 1&2" },
      { value: "EL2F", label: "EL2F-CODY 2 FILE MANAGEMENT" },
      { value: "EL3F", label: "EL3F-CODY 3 (OPEN SHELF FILES)" },
      { value: "EL51", label: "EL51-BUILDING 51 USED FOR PUMV" },
      { value: "ELB1", label: "ELB1-BELVEDERE  (OPEN SHELF FILES)" },
      { value: "ELBF", label: "ELBF-BRUNSWICK (OPEN SHELF)" },
      { value: "ELBS", label: "ELBS-London - Barchester Street" },
      { value: "ELBV", label: "ELBV-BELVEDERE" },
      { value: "ELBW", label: "ELBW-BRUNSWICK" },
      { value: "ELC1", label: "ELC1-CODY 1" },
      { value: "ELC2", label: "ELC2-CODY 2" },
      { value: "ELC3", label: "ELC3-CODY 3" },
      { value: "ELC4", label: "ELC4-CODY 4" },
      { value: "ELCH", label: "ELCH-London" },
      { value: "ELCI", label: "ELCI-CENTRAL INBOUND LONDON" },
      { value: "ELCO", label: "ELCO-Coulsdon" },
      { value: "ELCT", label: "ELCT-CANNING TOWN" },
      { value: "ELER", label: "ELER-ERROR BUILDING" },
      { value: "ELHC", label: "ELHC-HIGHCROSS" },
      { value: "ELHF", label: "ELHF-HIGHCROSS (OPEN SHELF)" },
      { value: "ELHH", label: "ELHH-HEMEL HEMPSTEAD" },
      { value: "ELHO", label: "ELHO-HEMEL HEMPSTED (OPEN SHELF)" },
      { value: "ELIC", label: "ELIC-Stone" },
      { value: "ELLP", label: "ELLP-LONDON PROJECTS" },
      { value: "ELOF", label: "ELOF-OTTERHAM QUAY (OPEN FILE)" },
      { value: "ELOQ", label: "ELOQ-OTTERHAM QUAY" },
      { value: "ELOS", label: "ELOS-EISENHOWER CENTRE OPENSHELF" },
      { value: "ELPF", label: "ELPF-POPLAR GAS (OPEN SHELF)" },
      { value: "ELPG", label: "ELPG-POPLAR (GAS)" },
      { value: "ELPP", label: "ELPP-POPLAR FAST" },
      { value: "ELRD", label: "ELRD-London - Ravensdale" },
      { value: "ELS0", label: "ELS0-London Shred Plant" },
      { value: "ELSY", label: "ELSY-FILE EXPRESS" },
      { value: "ELTL", label: "ELTL-STOCKWELL" },
      { value: "ELTM", label: "ELTM-STOCKWELL (OPEN SHELF)" },
      { value: "ELTR", label: "ELTR-TRAINING AT CODY 1" },
      { value: "ELTS", label: "ELTS-IKE - EISENHOWER TOWER" },
      { value: "ELVA", label: "ELVA-KIDBROOKE" },
      { value: "ELWC", label: "ELWC-London - Whitechapel" },
      { value: "ELWH", label: "ELWH-WHITE HART TRIANGLE" },
      { value: "ELWJ", label: "ELWJ-WHITE HART TRIANGLE OS" },
      { value: "ELWL", label: "ELWL-WHITE HART TRIANGLE GAS" },
      { value: "ELWS", label: "ELWS-HODDESDON DMS" },
      { value: "ELWU", label: "ELWU-HODDESDON" },
      { value: "ELZ1", label: "ELZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "EM",
    label: "EM-Manchester",
    buildings: [
      { value: "EM05", label: "EM05-OL HEYWOOD" },
      { value: "EM06", label: "EM06-OL CHADDERTON" },
      { value: "EMCF", label: "EMCF-OL CHADDERTON OF" },
      { value: "EMER", label: "EMER-ERROR BUILDING(WARRINGTON)" },
      { value: "EMHF", label: "EMHF-HEYWOOD OPEN FILING" },
      { value: "EMMD", label: "EMMD-MIDDLETON" },
      { value: "EMPA", label: "EMPA-ST PRIME POINT AEGON STAFFORD" },
      { value: "EMPF", label: "EMPF-ST STAFFORD OPEN FILING" },
      { value: "EMPH", label: "EMPH-PRIME POINT" },
      { value: "EMPP", label: "EMPP-ST PRIME POINT STAFFORD" },
      { value: "EMS0", label: "EMS0-Manchester Shred Plant" },
      { value: "EMSN", label: "EMSN-STONE BPM SCANNING SITE" },
      { value: "EMTR", label: "EMTR-INTERNAL T" },
      { value: "EMWF", label: "EMWF-LS WAKEFIELD OF" },
      { value: "EMWK", label: "EMWK-LS WAKEFIELD (PRIMA HOUSE)" },
      { value: "EMWO", label: "EMWO-WARRINGTON OPEN FILE" },
      { value: "EMWT", label: "EMWT-WA WARRINGTON" },
      { value: "EMXC", label: "EMXC-HAYWOOD" },
      { value: "EMXD", label: "EMXD-WARRINGTON" },
      { value: "EMXO", label: "EMXO-GEMINI OPEN FILE" },
      { value: "EMZ1", label: "EMZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "EN",
    label: "EN-Newcastle",
    buildings: [
      { value: "ENCI", label: "ENCI-CANNING TOWN INTERNAL TRANSFER" },
      { value: "ENGO", label: "ENGO-EN GATESHEAD OF" },
      { value: "ENGT", label: "ENGT-EN GATESHEAD" },
      { value: "ENS0", label: "ENS0-Newcastle Shred Plant" },
      { value: "ENZ1", label: "ENZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "ER",
    label: "ER-Rotterdam",
    buildings: [
      { value: "ER3W", label: "ER3W-Amsterdam - Schepenbergweg" },
      { value: "ERAR", label: "ERAR-Aphen aan den Rijn" },
      { value: "ERIC", label: "ERIC-Aphen aan den Rijn" },
      { value: "ERIE", label: "ERIE-Eindhoven" },
      { value: "ERPM", label: "ERPM-Amsterdam - Portsmuiden" },
      { value: "ERRD", label: "ERRD-Rotterdam - Cairostraat" },
      { value: "ERS0", label: "ERS0-Rotterdam Shred Plant" },
      { value: "ERSD", label: "ERSD-Amsterdam - Pleimuden" },
      { value: "ERTB", label: "ERTB-Tilburg" },
      { value: "ERZ1", label: "ERZ1-ER Virtual Destruction Building" },
    ],
  },
  {
    value: "ES",
    label: "ES-Birmingham",
    buildings: [
      { value: "ES10", label: "ES10-WITTON UNIT 10" },
      { value: "ES11", label: "ES11-WITTON UNIT 11" },
      { value: "ES52", label: "ES52-OLNEY" },
      { value: "ESAF", label: "ESAF-WITTON UNIT AF OF" },
      { value: "ESCW", label: "ESCW-CORBY" },
      { value: "ESEF", label: "ESEF-EGERTON RD OF" },
      { value: "ESEG", label: "ESEG-EGERTON RD" },
      { value: "ESGL", label: "ESGL-CORBY 2" },
      { value: "ESHB", label: "ESHB-THE HUB" },
      { value: "ESHF", label: "ESHF-THE HUB OF" },
      { value: "ESKF", label: "ESKF-KPMG OPEN SHELF" },
      { value: "ESMF", label: "ESMF-MERLIN PARK OF" },
      { value: "ESMP", label: "ESMP-MERLIN PARK" },
      { value: "ESS0", label: "ESS0-Birmingham Shred Plant" },
      { value: "ESTK", label: "ESTK-MIDPOINT" },
      { value: "ESTP", label: "ESTP-RUGBY" },
      { value: "ESXF", label: "ESXF-NORTHAMPTON" },
      { value: "ESZ1", label: "ESZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "EY",
    label: "EY-Kings Lynn",
    buildings: [
      { value: "EYGF", label: "EYGF-GREYFRIARS" },
      { value: "EYKF", label: "EYKF-KINGS LYNN (OPEN FILE)" },
      { value: "EYKN", label: "EYKN-KINGS LYNN" },
      { value: "EYS0", label: "EYS0-Kings Lynn Shred Plant" },
      { value: "EYZ1", label: "EYZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "FA",
    label: "FA-Les Arcs sur Argens",
    buildings: [
      { value: "FALA", label: "FALA-Les Arcs sur Argens" },
      { value: "FAS0", label: "FAS0-Les Arcs sur Argens Shred Plant" },
      { value: "FASC", label: "FASC-Bordeaux" },
      { value: "FASD", label: "FASD-Dijon" },
      { value: "FASF", label: "FASF-Lyon" },
      { value: "FASP", label: "FASP-Bruguiers" },
      { value: "FAXM", label: "FAXM-St. Martin" },
      { value: "FAYQ", label: "FAYQ-Teyran" },
      { value: "FAZ1", label: "FAZ1-FA Virtual Destruction Building" },
    ],
  },
  {
    value: "FC",
    label: "FC-Chartres",
    buildings: [
      { value: "FCCH", label: "FCCH-Champagne Sur Seine" },
      { value: "FCCS", label: "FCCS-Chartres" },
      { value: "FCCT", label: "FCCT-Gellainville" },
      { value: "FCCV", label: "FCCV-Gellainville" },
      { value: "FCIC", label: "FCIC-Chartres" },
      { value: "FCMC", label: "FCMC-MOISSY CRAMAYEL" },
      { value: "FCMO", label: "FCMO-Morangis" },
      { value: "FCRS", label: "FCRS-Chartres" },
      { value: "FCS0", label: "FCS0-Chartres Shred Plant" },
      { value: "FCSJ", label: "FCSJ-Guy de Longrois" },
      { value: "FCUO", label: "FCUO-Mignieres" },
      { value: "FCZ1", label: "FCZ1-FC Virtual Destruction Building" },
    ],
  },
  {
    value: "FN",
    label: "FN-France North",
    buildings: [
      { value: "FNSO", label: "FNSO-Strasbourg" },
      { value: "FNTV", label: "FNTV-Roubaix" },
      { value: "FNUP", label: "FNUP-Compans" },
      { value: "FNWA", label: "FNWA-Canly" },
      { value: "FNYP", label: "FNYP-Thorigny Sur Marne" },
      { value: "FNZ1", label: "FNZ1-FN Virtual Destruction Building" },
    ],
  },
  {
    value: "FO",
    label: "FO-OUEST FRANCE",
    buildings: [
      { value: "FOCN", label: "FOCN-Verson" },
      { value: "FOHD", label: "FOHD-HEUDEBOUVILLE" },
      { value: "FOIC", label: "FOIC-Le Mans" },
      { value: "FOLM", label: "FOLM-Le Mans" },
      { value: "FOR0", label: "FOR0-La Meziere" },
      { value: "FORN", label: "FORN-La Meziere" },
      { value: "FOS0", label: "FOS0-Le Mans Shred Plant" },
      { value: "FOSD", label: "FOSD-Saint-Denis la Chevasse" },
      { value: "FOSI", label: "FOSI-Coignieres 1-2" },
      { value: "FOSM", label: "FOSM-Coignieres 3" },
      { value: "FOSQ", label: "FOSQ-TOURS" },
      { value: "FOSS", label: "FOSS-Louailles" },
      { value: "FOTP", label: "FOTP-TRAPPES" },
      { value: "FOTY", label: "FOTY-Coignieres 4-5-6" },
      { value: "FOTZ", label: "FOTZ-Coignieres 8" },
      { value: "FOUA", label: "FOUA-Coignieres 9" },
      { value: "FOZ1", label: "FOZ1-FO Virtual Destruction Building" },
    ],
  },
  {
    value: "GB",
    label: "GB-Customer Services UK",
    buildings: [
      { value: "GBBS", label: "GBBS-BELVEDER OLYMPIC TEST" },
      { value: "GBBW", label: "GBBW-BRUNSWICK TEST BUILDING" },
      { value: "GBC3", label: "GBC3-C3 TEST BUILDING" },
      { value: "GBC4", label: "GBC4-CODY 4 TEST BUILDING" },
      { value: "GBCI", label: "GBCI-INBOUND HUB" },
      { value: "GBHC", label: "GBHC-HIGHCROSS TEST BUILDING" },
      { value: "GBHH", label: "GBHH-HEMEL OLYMPIC TEST BUILDING" },
      { value: "GBHR", label: "GBHR-HEATHROW OLYMPIC TEST BUILDING" },
      { value: "GBIC", label: "GBIC-IMAGE CENTER" },
      { value: "GBOQ", label: "GBOQ-OTTERHAM OLYMPIC TEST BUILDING" },
      { value: "GBOS", label: "GBOS-C2 OPENSHELF TEST" },
      { value: "GBPP", label: "GBPP-POPLAR TEST BUILDING" },
      { value: "GBQA", label: "GBQA-CODY1 OLYMPIC TEST BUILDING" },
      { value: "GBRF", label: "GBRF-RFID TEST" },
      { value: "GBS0", label: "GBS0-Test - Shredding Center" },
      { value: "GBSO", label: "GBSO-SMITHFIELD OPENSHELF" },
      { value: "GBSS", label: "GBSS-RAVENSDALE TEST BUILDING" },
      { value: "GBTR", label: "GBTR-TEST BUILDING" },
      { value: "GBTS", label: "GBTS-WHITE HART TESTING BUILDING" },
      { value: "GBWC", label: "GBWC-WHITECHAPLE TEST BUILDING" },
      { value: "GBZ1", label: "GBZ1-IB VIRTUAL DESTRUCTION BUILDING" },
    ],
  },
  {
    value: "HA",
    label: "HA-Aspropyrgos",
    buildings: [
      { value: "HA02", label: "HA02-Aspropyrgos" },
      { value: "HAAA", label: "HAAA-Aspropyrgos" },
      { value: "HAAB", label: "HAAB-Aspropyrgos" },
      { value: "HAF2", label: "HAF2-Aspropyrgos" },
      { value: "HAS0", label: "HAS0-Aspropyrgos Shred Plant" },
    ],
  },
  {
    value: "HB",
    label: "HB-Gyal",
    buildings: [
      { value: "HB01", label: "HB01-Gyal" },
      { value: "HB02", label: "HB02-Gyal" },
      { value: "HB03", label: "HB03-Gyor" },
      { value: "HBS0", label: "HBS0-Gyal Shred Plant" },
    ],
  },
  {
    value: "IB",
    label: "IB-Antrim",
    buildings: [
      { value: "IBA1", label: "IBA1-Antrim" },
      { value: "IBAM", label: "IBAM-Antrim" },
      { value: "IBAN", label: "IBAN-Antrim 2 Record Centre" },
      { value: "IBIC", label: "IBIC-Antrim" },
      { value: "IBP1", label: "IBP1-Projetcs Team Record Centre" },
      { value: "IBS0", label: "IBS0-Antrim Shred Plant" },
      { value: "IBT1", label: "IBT1-Antrim" },
      { value: "IBVT", label: "IBVT-ANTRIM VAULT" },
      { value: "IBZ1", label: "IBZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "IC",
    label: "IC-Cork",
    buildings: [
      { value: "ICCG", label: "ICCG-Cork - Carrigtwohill" },
      { value: "ICEL", label: "ICEL-ELI LILLY Record Centre" },
      { value: "ICIC", label: "ICIC-Cork - Carrigtwohill" },
      { value: "ICS0", label: "ICS0-Cork Shred Plant" },
      { value: "ICZ1", label: "ICZ1-IC VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "ID",
    label: "ID-Dublin",
    buildings: [
      { value: "IDAT", label: "IDAT-ATHY" },
      { value: "IDB2", label: "IDB2-Dublin - Rosemount" },
      { value: "IDBL", label: "IDBL-Dublin - Rosemount" },
      { value: "IDCL", label: "IDCL-Dublin - Clondalkin" },
      { value: "IDD2", label: "IDD2-Dublin - Damastown" },
      { value: "IDDA", label: "IDDA-Dublin - Damastown" },
      { value: "IDIC", label: "IDIC-Dublin - Rosemount" },
      { value: "IDNM", label: "IDNM-Dublin - New Market" },
      { value: "IDPJ", label: "IDPJ-IDPJ Projetcs Team Record Centre" },
      { value: "IDS0", label: "IDS0-Dublin Shred Plant" },
      { value: "IDSC", label: "IDSC-IDSC Scanning Department" },
      { value: "IDZ1", label: "IDZ1-ID VIRTUAL DESTRUCTION BULDING" },
    ],
  },
  {
    value: "IL",
    label: "IL-Limerick",
    buildings: [
      { value: "IL01", label: "IL01-Limerick" },
      { value: "ILIC", label: "ILIC-Limerick" },
      { value: "ILPJ", label: "ILPJ-ILPJ Projects Record centre" },
      { value: "ILS0", label: "ILS0-Limerick Shred Plant" },
      { value: "ILZ1", label: "ILZ1-IL VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "ME",
    label: "ME-Madrid",
    buildings: [
      { value: "ME01", label: "ME01-Madrid - Daganzo" },
      { value: "ME02", label: "ME02-Madrid - Daganzo" },
      { value: "ME03", label: "ME03-Chiloeches, Guadalajara" },
      { value: "MEIC", label: "MEIC-Chiloeches, Guadalajara" },
      { value: "MES0", label: "MES0-Madrid Shred Plant" },
      { value: "METH", label: "METH-DAGANZO RECALL" },
      { value: "METI", label: "METI-RIBATEJADA" },
      { value: "MEZ1", label: "MEZ1-ME VIRTUAL DESTRUCTION BUILDING" },
    ],
  },
  {
    value: "NS",
    label: "NS-Tananger",
    buildings: [
      { value: "NSS0", label: "NSS0-Tananger Shred Plant" },
      { value: "NSST", label: "NSST-Tananger" },
    ],
  },
  { value: "R", label: "R-Romania", buildings: [] },
  {
    value: "R0",
    label: "R0-Romania",
    buildings: [
      { value: "R002", label: "R002-Ploiesti" },
      { value: "R004", label: "R004-Bucharest" },
      { value: "R0S0", label: "R0S0-Romania Shred Plant" },
    ],
  },
  {
    value: "RE",
    label: "RE-Rivas",
    buildings: [
      { value: "RERB", label: "RERB-Rivas-Vaciamadrid" },
      { value: "RERO", label: "RERO-Rivas-Vaciamadrid" },
      { value: "RES0", label: "RES0-Rivas Shred Plant" },
    ],
  },
  {
    value: "SK",
    label: "SK-Bratislava",
    buildings: [
      { value: "SK01", label: "SK01-Bratislava" },
      { value: "SK02", label: "SK02-Bratislava" },
      { value: "SKS0", label: "SKS0-Bratislava Shred Plant" },
    ],
  },
  {
    value: "ST",
    label: "ST-Glasgow",
    buildings: [
      { value: "STBS", label: "STBS-Glasgow - Baird Street" },
      { value: "STDC", label: "STDC-MURRAYBURN" },
      { value: "STGH", label: "STGH-HELEN STREET" },
      { value: "STGO", label: "STGO-GLASGOW OPEN SHELF" },
      { value: "STIK", label: "STIK-INVERKEITHING" },
      { value: "STIN", label: "STIN-INNERLEITHEN" },
      { value: "STL1", label: "STL1-LIVINGSTON TRAINING BUILDING" },
      { value: "STLD", label: "STLD-LIVINGSTON" },
      { value: "STLE", label: "STLE-LIVINGSTON" },
      { value: "STLI", label: "STLI-LIVINGSTON INTAKES" },
      { value: "STLM", label: "STLM-LIVINGSTON" },
      { value: "STLN", label: "STLN-LIVINGSTON" },
      { value: "STLO", label: "STLO-LIVINGSTON" },
      { value: "STLS", label: "STLS-LIVINGSTON" },
      { value: "STLW", label: "STLW-LIVINGSTON" },
      { value: "STS0", label: "STS0-Glasgow Shred Plant" },
      { value: "STZ1", label: "STZ1-IB VIRTUAL DESTRUCTION BUILDIN" },
    ],
  },
  {
    value: "VE",
    label: "VE-VALENCIA ESPANA",
    buildings: [
      { value: "VEWD", label: "VEWD-VALENCIA BUILDING WD" },
      { value: "VEWL", label: "VEWL-VALENCIA BUILDING WL" },
      { value: "VEWM", label: "VEWM-VALENCIA BUILDING WM" },
      { value: "VEWO", label: "VEWO-VALENCIA BUILDING WO" },
      { value: "VEWQ", label: "VEWQ-VALENCIA BUILDING WQ" },
      { value: "VEWR", label: "VEWR-VALENCIA BUILDING WR" },
      { value: "VEWS", label: "VEWS-VALENCIA BUILDING WS" },
      { value: "VEWT", label: "VEWT-VALENCIA BUILDING WT" },
      { value: "VEWW", label: "VEWW-VALENCIA BUILDING WW" },
      { value: "VEZ1", label: "VEZ1-VE VIRTUAL DESTRUCTION BUILDING" },
    ],
  },
  { value: "WM", label: "WM-West Manchester", buildings: [] },
  {
    value: "ZE",
    label: "ZE-Zaragoza",
    buildings: [
      { value: "ZE01", label: "ZE01-Zaragoza" },
      { value: "ZE02", label: "ZE02-Zaragoza" },
      { value: "ZEF1", label: "ZEF1-Zaragoza" },
      { value: "ZES0", label: "ZES0-Zaragoza Shred Plant" },
      { value: "ZEZ1", label: "ZEZ1-ZE VIRTUAL DESTRUCTION BUILDING" },
    ],
  },
];

export const BUILDINGS = [
  { value: "AE02", label: "AE02-Seville" },
  { value: "AES0", label: "AES0-Seville Shred Plant" },
  { value: "AEZ1", label: "AEZ1-AE VIRTUAL DESTRUCTION BULDING" },
];

export const ACTIVITY_GROUP = {
  es: [
    { label: "No transaccional", value: "Non-Transactional" },
    { label: "Transaccional", value: "Transactional" },
  ],
  ru: [
    { label: "Нетранзакционная", value: "Non-Transactional" },
    { label: "Транзакционная", value: "Transactional" },
  ],
  nl: [
    { label: "Niet-transactionele", value: "Non-Transactional" },
    { label: "Transactional", value: "Transactional" },
  ],
  fr: [
    { label: "Non transactionnel", value: "Non-Transactional" },
    { label: "Transactionnelle", value: "Transactional" },
  ],
  pt: [
    { label: "Não Transacional", value: "Non-Transactional" },
    { label: "Transacional", value: "Transactional" },
  ],
  en: [
    { label: "Non-Transactional", value: "Non-Transactional" },
    { label: "Transactional", value: "Transactional" },
  ],
  tr: [
    { label: "Sigara İşlemsel", value: "Non-Transactional" },
    { label: "İşlem", value: "Transactional" },
  ],
  el: [
    { label: "Μη συναλλαγών", value: "Non-Transactional" },
    { label: "Συναλλακτική", value: "Transactional" },
  ],
  rm: [
    { label: "Non-tranzacționale", value: "Non-Transactional" },
    { label: "Tranzactionala", value: "Transactional" },
  ],
  de: [
    { label: "Nicht transaktional", value: "Non-Transactional" },
    { label: "Transaktion", value: "Transactional" },
  ],
};

export const JOB_FAMILIES = {
  ru: [
    {
      label: "Художественный администратор",
      value: "Art Admin",
      projectInfoEntryType: "none",
    },
    {
      label: "Упаковка предметов искусства",
      value: "Art Crate",
      projectInfoEntryType: "none",
    },
    {
      label: "Поддержание предметов искусства",
      value: "Art Maint",
      projectInfoEntryType: "none",
    },
    {
      label: "Художественный специалист",
      value: "Art Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Транспортировка предметов искусства",
      value: "Art Trans",
      projectInfoEntryType: "none",
    },
    {
      label: "Временный сотрудник отдела цифровых решений",
      value: "CWK DS Spec",
      projectInfoEntryType: "id",
    },
    {
      label:
        "Временный сотрудник службы клиентской поддержки по услугам хранения",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "Временный сотрудник отдела индексации",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Временный специалист архивного хранилища",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Временный специалист предостатавления информации по запросу",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Временный сотрудник отдела уничтожения",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Специалист отдела цифровых решений",
      value: "DS Spec",
      projectInfoEntryType: "id",
    },
    { label: "Не Доступно", value: "NA", projectInfoEntryType: "none" },
    {
      label: "Сотрудник на территории клиента",
      value: "Outsourced",
      projectInfoEntryType: "none",
    },
    {
      label: "Специалист ариивного хранилища bus sprt",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Представитель службы клиентской поддержки по услугам хранения",
      value: "RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "Сотрудник отдела индексации",
      value: "RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Обслуживание хранилища",
      value: "RC Maint",
      projectInfoEntryType: "none",
    },
    {
      label: "Специалист архивного хранилища",
      value: "RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Специалист предоставления информации по запросу",
      value: "ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Обслуживание отдела конфиденциального уничтожения",
      value: "SS Maint",
      projectInfoEntryType: "none",
    },
    {
      label: "Специалист отдела конфиденциальное уничтожение",
      value: "SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "Продажи", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Управление транспортировкой данных",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    {
      label: "Транспортировка управления информацией",
      value: "Trans RIM",
      projectInfoEntryType: "none",
    },
    {
      label: "Выездное шредирование",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    {
      label: "Специалист хранилища медианосителей",
      value: "Vault Spec",
      projectInfoEntryType: "none",
    },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
  nl: [
    { label: "Art Admin", value: "Art Admin", projectInfoEntryType: "none" },
    { label: "Art Crate", value: "Art Crate", projectInfoEntryType: "none" },
    { label: "Art Maint", value: "Art Maint", projectInfoEntryType: "none" },
    { label: "Art Spec", value: "Art Spec", projectInfoEntryType: "none" },
    { label: "Art Trans", value: "Art Trans", projectInfoEntryType: "none" },
    {
      label: "DS Specialist uitzend",
      value: "CWK DS Spec",
      projectInfoEntryType: "id",
    },
    {
      label: "CWK RC CS Rep",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "DC data entry specialist uitzend",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "DC specialist uitzend",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK ROI Spec",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK SS Spec",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "DS Specialist", value: "DS Spec", projectInfoEntryType: "id" },
    { label: "Niet toepasbaar", value: "NA", projectInfoEntryType: "none" },
    { label: "Uitbesteed", value: "Outsourced", projectInfoEntryType: "none" },
    {
      label: "RC Bus Sprt Spec",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC CS Rep", value: "RC CS Rep", projectInfoEntryType: "none" },
    {
      label: "DC data entry specialist",
      value: "RC DE Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC Maint", value: "RC Maint", projectInfoEntryType: "none" },
    { label: "DC Specialist", value: "RC Spec", projectInfoEntryType: "none" },
    { label: "ROI Spec", value: "ROI Spec", projectInfoEntryType: "none" },
    { label: "SS Maint", value: "SS Maint", projectInfoEntryType: "none" },
    { label: "SS Spec", value: "SS Spec", projectInfoEntryType: "none" },
    { label: "Sales", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Transport DM",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    { label: "Transport RM", value: "Trans RIM", projectInfoEntryType: "none" },
    {
      label: "Trans Shred",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    {
      label: "DM Specialist",
      value: "Vault Spec",
      projectInfoEntryType: "none",
    },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
  fr: [
    {
      label: "N'est pas applicable",
      value: "Art Admin",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "Art Crate",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "Art Maint",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "Art Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "Art Trans",
      projectInfoEntryType: "none",
    },
    {
      label: "Opérateur Temp GED",
      value: "CWK DS Spec",
      projectInfoEntryType: "id",
    },
    {
      label: "N'est pas applicable",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "Spécialiste Temp Entrée de Données",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Spécialiste Temp RM",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "Opérateur GED", value: "DS Spec", projectInfoEntryType: "id" },
    {
      label: "N'est pas applicable",
      value: "NA",
      projectInfoEntryType: "none",
    },
    { label: "Externalisé", value: "Outsourced", projectInfoEntryType: "none" },
    {
      label: "N'est pas applicable",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "Spécialiste Entrée de Données",
      value: "RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "RC Maint",
      projectInfoEntryType: "none",
    },
    { label: "Spécialiste RM", value: "RC Spec", projectInfoEntryType: "none" },
    {
      label: "N'est pas applicable",
      value: "ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "SS Maint",
      projectInfoEntryType: "none",
    },
    { label: "Support Ventes", value: "SS Spec", projectInfoEntryType: "none" },
    { label: "Ventes", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Transport DM",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    { label: "Transport RM", value: "Trans RIM", projectInfoEntryType: "none" },
    {
      label: "N'est pas applicable",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    {
      label: "Spécialiste DM",
      value: "Vault Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "N'est pas applicable",
      value: "WDC",
      projectInfoEntryType: "none",
    },
  ],
  pt: [
    { label: "Art Admin", value: "Art Admin", projectInfoEntryType: "none" },
    { label: "Art Caixa", value: "Art Crate", projectInfoEntryType: "none" },
    { label: "Art Maint", value: "Art Maint", projectInfoEntryType: "none" },
    {
      label: "Especificação da Arte",
      value: "Art Spec",
      projectInfoEntryType: "none",
    },
    { label: "Art Trans", value: "Art Trans", projectInfoEntryType: "none" },
    { label: "CWK DS Spec", value: "CWK DS Spec", projectInfoEntryType: "id" },
    {
      label: "Representante de CWK RC CS",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK RC DE Spec",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK RC Spec",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK ROI Spec",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK SS Spec",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "DS Spec", value: "DS Spec", projectInfoEntryType: "id" },
    { label: "Não aplicável", value: "NA", projectInfoEntryType: "none" },
    {
      label: "Terceirizado",
      value: "Outsourced",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Bus Sprt Spec",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC CS Rep", value: "RC CS Rep", projectInfoEntryType: "none" },
    { label: "RC DE Spec", value: "RC DE Spec", projectInfoEntryType: "none" },
    { label: "RC Maint", value: "RC Maint", projectInfoEntryType: "none" },
    { label: "RC Spec", value: "RC Spec", projectInfoEntryType: "none" },
    {
      label: "Especificações de ROI",
      value: "ROI Spec",
      projectInfoEntryType: "none",
    },
    { label: "SS Maint", value: "SS Maint", projectInfoEntryType: "none" },
    { label: "SS Spec", value: "SS Spec", projectInfoEntryType: "none" },
    { label: "Vendas", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Transporte Data Mgt",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    {
      label: "Transporte RIM",
      value: "Trans RIM",
      projectInfoEntryType: "none",
    },
    {
      label: "Transporte Shred",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    {
      label: "Especificações do Vault",
      value: "Vault Spec",
      projectInfoEntryType: "none",
    },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
  en: [
    { label: "Art Admin", value: "Art Admin", projectInfoEntryType: "none" },
    { label: "Art Crate", value: "Art Crate", projectInfoEntryType: "none" },
    { label: "Art Maint", value: "Art Maint", projectInfoEntryType: "none" },
    { label: "Art Spec", value: "Art Spec", projectInfoEntryType: "none" },
    { label: "Art Trans", value: "Art Trans", projectInfoEntryType: "none" },
    { label: "CWK DS Spec", value: "CWK DS Spec", projectInfoEntryType: "id" },
    {
      label: "CWK RC CS Rep",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK RC DE Spec",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK RC Spec",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK ROI Spec",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK SS Spec",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "DS Spec", value: "DS Spec", projectInfoEntryType: "id" },
    { label: "NA", value: "NA", projectInfoEntryType: "none" },
    { label: "Outsourced", value: "Outsourced", projectInfoEntryType: "none" },
    {
      label: "RC Bus Sprt Spec",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC CS Rep", value: "RC CS Rep", projectInfoEntryType: "none" },
    { label: "RC DE Spec", value: "RC DE Spec", projectInfoEntryType: "none" },
    { label: "RC Maint", value: "RC Maint", projectInfoEntryType: "none" },
    { label: "RC Spec", value: "RC Spec", projectInfoEntryType: "none" },
    { label: "ROI Spec", value: "ROI Spec", projectInfoEntryType: "none" },
    { label: "SS Maint", value: "SS Maint", projectInfoEntryType: "none" },
    { label: "SS Spec", value: "SS Spec", projectInfoEntryType: "none" },
    { label: "Sales", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Trans Data Mgt",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    { label: "Trans RIM", value: "Trans RIM", projectInfoEntryType: "none" },
    {
      label: "Trans Shred",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    { label: "Vault Spec", value: "Vault Spec", projectInfoEntryType: "none" },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
  tr: [
    {
      label: "Sanat Yöneticisi",
      value: "Art Admin",
      projectInfoEntryType: "none",
    },
    {
      label: "Sanat Sandığı",
      value: "Art Crate",
      projectInfoEntryType: "none",
    },
    { label: "Sanat Bakım", value: "Art Maint", projectInfoEntryType: "none" },
    { label: "Sanat Uzmanı", value: "Art Spec", projectInfoEntryType: "none" },
    { label: "Sanat Trans", value: "Art Trans", projectInfoEntryType: "none" },
    {
      label: "Geçici DS Uzmanı",
      value: "CWK DS Spec",
      projectInfoEntryType: "id",
    },
    {
      label: "Geçici RC MH Temsilcisi",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "Geçici RC VG Uzmanı",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Geçici RC Uzmanı",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Geçici Veri Uzmanıı",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Geçici Güvenli İmha Uzmanı",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "DS Uzmanı", value: "DS Spec", projectInfoEntryType: "id" },
    { label: "Uygulanamaz", value: "NA", projectInfoEntryType: "none" },
    { label: "Taşeron", value: "Outsourced", projectInfoEntryType: "none" },
    {
      label: "RC İş Destek Uzmanı",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "RC MH Temsilcisi",
      value: "RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "RC VG Uzmanı",
      value: "RC DE Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC Bakım", value: "RC Maint", projectInfoEntryType: "none" },
    { label: "RC Uzmanı", value: "RC Spec", projectInfoEntryType: "none" },
    { label: "Veri Uzmanı", value: "ROI Spec", projectInfoEntryType: "none" },
    {
      label: "Güvenli İmha Bakım",
      value: "SS Maint",
      projectInfoEntryType: "none",
    },
    {
      label: "Güvenli İmha Uzmanı",
      value: "SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "Satış", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Trans Veri Yönetimi",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    { label: "Trans RIM", value: "Trans RIM", projectInfoEntryType: "none" },
    { label: "Trans İmha", value: "Trans Shred", projectInfoEntryType: "none" },
    { label: "Kasa Uzmanı", value: "Vault Spec", projectInfoEntryType: "none" },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
  el: [
    {
      label: "Διαχειριστής τέχνης",
      value: "Art Admin",
      projectInfoEntryType: "none",
    },
    {
      label: "Κλουβί τέχνης",
      value: "Art Crate",
      projectInfoEntryType: "none",
    },
    { label: "Art Maint", value: "Art Maint", projectInfoEntryType: "none" },
    { label: "Εικ", value: "Art Spec", projectInfoEntryType: "none" },
    { label: "Art Trans", value: "Art Trans", projectInfoEntryType: "none" },
    {
      label: "Προδιαγραφές CWK DS",
      value: "CWK DS Spec",
      projectInfoEntryType: "id",
    },
    {
      label: "CWK RC CS Rep",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "Προδιαγραφές CWK RC DE",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Προδιαγραφές CWK RC",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Προδιαγραφές CWK ROI",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Προδιαγραφές CWK SS",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "Προδιαγραφές DS", value: "DS Spec", projectInfoEntryType: "id" },
    { label: "Δεν εφαρμόζεται", value: "NA", projectInfoEntryType: "none" },
    {
      label: "Εξωτερική ανάθεση",
      value: "Outsourced",
      projectInfoEntryType: "none",
    },
    {
      label: "Προδιαγραφές RC Bus Sprt",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC CS Rep", value: "RC CS Rep", projectInfoEntryType: "none" },
    {
      label: "Προδιαγραφές RC DE",
      value: "RC DE Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC Maint", value: "RC Maint", projectInfoEntryType: "none" },
    {
      label: "Προδιαγραφές RC",
      value: "RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Χαρακτηριστικά ROI",
      value: "ROI Spec",
      projectInfoEntryType: "none",
    },
    { label: "SS Maint", value: "SS Maint", projectInfoEntryType: "none" },
    {
      label: "Προδιαγραφές SS",
      value: "SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "Εκπτώσεις", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Trans Data Mgt",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    { label: "Trans RIM", value: "Trans RIM", projectInfoEntryType: "none" },
    {
      label: "Trans τεμαχισμένο",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    {
      label: "Προδιαγραφές Vault",
      value: "Vault Spec",
      projectInfoEntryType: "none",
    },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
  rm: [
    { label: "Art. Admin", value: "Art Admin", projectInfoEntryType: "none" },
    { label: "Art Crate", value: "Art Crate", projectInfoEntryType: "none" },
    { label: "Art Maint", value: "Art Maint", projectInfoEntryType: "none" },
    { label: "Art. Spec", value: "Art Spec", projectInfoEntryType: "none" },
    { label: "Art. Trans", value: "Art Trans", projectInfoEntryType: "none" },
    {
      label: "CWK DS Specialist",
      value: "CWK DS Spec",
      projectInfoEntryType: "id",
    },
    {
      label: "CWK RC CS Reprezentant",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK RC DE Specialist",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK RC Specialist",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK ROI Specialist",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK SS Specialist",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "DS Spec", value: "DS Spec", projectInfoEntryType: "id" },
    { label: "Nu se aplică", value: "NA", projectInfoEntryType: "none" },
    {
      label: "Subcontractor",
      value: "Outsourced",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Bus Sprt Spec",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC CS Rep", value: "RC CS Rep", projectInfoEntryType: "none" },
    { label: "RC DE Spec", value: "RC DE Spec", projectInfoEntryType: "none" },
    { label: "RC Maint", value: "RC Maint", projectInfoEntryType: "none" },
    { label: "RC Spec", value: "RC Spec", projectInfoEntryType: "none" },
    { label: "ROI Spec", value: "ROI Spec", projectInfoEntryType: "none" },
    { label: "SS Maint", value: "SS Maint", projectInfoEntryType: "none" },
    { label: "SS Spec", value: "SS Spec", projectInfoEntryType: "none" },
    { label: "Vânzări", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Trans Data Mgt",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    { label: "Trans RIM", value: "Trans RIM", projectInfoEntryType: "none" },
    {
      label: "Trans Distrugere",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    {
      label: "Stocare Securizata Spec",
      value: "Vault Spec",
      projectInfoEntryType: "none",
    },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
  de: [
    { label: "Art Admin", value: "Art Admin", projectInfoEntryType: "none" },
    { label: "Kunstkiste", value: "Art Crate", projectInfoEntryType: "none" },
    { label: "Art Maint", value: "Art Maint", projectInfoEntryType: "none" },
    { label: "Art Spec", value: "Art Spec", projectInfoEntryType: "none" },
    { label: "Art Trans", value: "Art Trans", projectInfoEntryType: "none" },
    { label: "CWK DS Spec", value: "CWK DS Spec", projectInfoEntryType: "id" },
    {
      label: "CWK RC CS Rep",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK RC DE Spec",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK RC Spec",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK ROI Spec",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "CWK SS Spec",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "DS Spec", value: "DS Spec", projectInfoEntryType: "id" },
    { label: "Unzutreffend", value: "NA", projectInfoEntryType: "none" },
    { label: "Ausgelagert", value: "Outsourced", projectInfoEntryType: "none" },
    {
      label: "RC Bus Sprt Spec",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    { label: "RC CS Rep", value: "RC CS Rep", projectInfoEntryType: "none" },
    { label: "RC DE Spec", value: "RC DE Spec", projectInfoEntryType: "none" },
    { label: "RC Maint", value: "RC Maint", projectInfoEntryType: "none" },
    { label: "RC Spec", value: "RC Spec", projectInfoEntryType: "none" },
    { label: "ROI Spec", value: "ROI Spec", projectInfoEntryType: "none" },
    { label: "SS Maint", value: "SS Maint", projectInfoEntryType: "none" },
    { label: "SS Spec", value: "SS Spec", projectInfoEntryType: "none" },
    { label: "Der Umsatz", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Trans Data Mgt",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    { label: "Trans RIM", value: "Trans RIM", projectInfoEntryType: "none" },
    {
      label: "Trans Shred",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    { label: "Vault Spec", value: "Vault Spec", projectInfoEntryType: "none" },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
  es: [
    {
      label: "Administrador de arte",
      value: "Art Admin",
      projectInfoEntryType: "none",
    },
    { label: "Caja de arte", value: "Art Crate", projectInfoEntryType: "none" },
    {
      label: "Art Mantenimiento",
      value: "Art Maint",
      projectInfoEntryType: "none",
    },
    {
      label: "Art Especialista",
      value: "Art Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Art Transporte",
      value: "Art Trans",
      projectInfoEntryType: "none",
    },
    {
      label: "DS Especialista Temporal",
      value: "CWK DS Spec",
      projectInfoEntryType: "id",
    },
    {
      label: "RC Representante Servicio al Cliente Temporal",
      value: "CWK RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Especialista Temporal Data Entry",
      value: "CWK RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Especialista Temporal",
      value: "CWK RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "ROI Especialista Temporal",
      value: "CWK ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "SS Especialista Temporal",
      value: "CWK SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "DS Especialista", value: "DS Spec", projectInfoEntryType: "id" },
    { label: "No aplica", value: "NA", projectInfoEntryType: "none" },
    {
      label: "Subcontratado / Tercerizado",
      value: "Outsourced",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Especialista Soporte de Negocios",
      value: "RC Bus Sprt Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Representante Servicio al Cliente",
      value: "RC CS Rep",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Especialista Data Entry ",
      value: "RC DE Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Mantenimiento",
      value: "RC Maint",
      projectInfoEntryType: "none",
    },
    {
      label: "RC Especialista",
      value: "RC Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "Especificaciones de ROI",
      value: "ROI Spec",
      projectInfoEntryType: "none",
    },
    {
      label: "SS Mantenimiento",
      value: "SS Maint",
      projectInfoEntryType: "none",
    },
    {
      label: "SS Especialista",
      value: "SS Spec",
      projectInfoEntryType: "none",
    },
    { label: "Ventas", value: "Sales", projectInfoEntryType: "none" },
    {
      label: "Transporte Data Mgt",
      value: "Trans Data Mgt",
      projectInfoEntryType: "none",
    },
    {
      label: "Transporte RIM",
      value: "Trans RIM",
      projectInfoEntryType: "none",
    },
    {
      label: "Transporte Shred",
      value: "Trans Shred",
      projectInfoEntryType: "none",
    },
    {
      label: "Vault Especialista",
      value: "Vault Spec",
      projectInfoEntryType: "none",
    },
    { label: "WDC", value: "WDC", projectInfoEntryType: "none" },
  ],
};

export const EXCEPTIONS = {
  es: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  ru: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  nl: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  fr: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  pt: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  en: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  tr: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  el: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  rm: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
  de: [
    { label: "No Exception", value: "no exception" },
    { label: "Missed Clock In", value: "missed clock in" },
    { label: "Missed Clock Out", value: "missed clock out" },
  ],
};

export const PUNCHES = [
  { value: "IN", label: "Clock In" },
  { value: "OUT", label: "Clock Out" },
  { value: "TRANSFER", label: "Transfer" },
];

export const SET_EMPTY = "";
export const PROJECTID ="Project ID";
export const SPECIAL_PROJECT = "project";
export const PROJECT = "Project";
export const PROJECT_DETAILS = "Project Details";
export const DIGITAL_SOLUTIONS_IMAGING = "id";
export const CLOCK_IN = "IN";
export const CLOCK_OUT = "OUT";
export const TRANSFER = "TRANSFER";
export const MISSED_CLOCK_IN = "missed clock in";
export const MISSED_CLOCK_OUT = "missed clock out";
export const NO_EXCEPTION = "no exception";
export const STATUS = "new";
export const DEFAULT_JOB_FAMILY = "DS Spec";
export const DEFAULT_ACTIVITY_GROUP = "Transactional";
export const DEFAULT_DISTRICT = "AE";
export const DEFAULT_BUILDING = "AE02";
export const DEFAULT_EXCEPTION = "no exception";
export const DEFAULT_PUNCH = "clock in";

export const EDIT_STATUS = "edit";
export const NEW_STATUS = "new";
export const APPROVED_STATUS = "approved";
export const PENDING_STATUS = "pending";
export const INCOMPLETE_STATUS = "incomplete";
export const EXCEPTION_STATUS = "exception";
export const DELETED_STATUS = "deleted";
export const AUTO_COMPLETE_STATUS = "auto completed";
export const AUTO_APPROVED_STATUS = "auto approved";
export const AUTO_ADJUSTED_STATUS = "auto adjusted";

export const INCOMPLETE_BG_VALID = "#f2c3c5";
export const INCOMPLETE_BG_INVALID = "#cacaca";
export const DURATION_GT_12 = "#fff200";
export const TWELVE = 12;
export const NON_TRANSACTIONAL = "Non-Transactional";
export const PTO = "PTO";
export const CONFIRMATION = "Confirmation";
export const AUTO_ADJUST_TRIP_MILEAGE = 1;
export const AUTO_CLOCK_OUT_TIME_DIFF = 18;
export const dateConfig = {
  format1: "dddd, MMM Do", // shows date like Monday, June 1st
  format2: "DD/MM", // shows date like 09/06
  format3: "DD/MM/YYYY", // day month year
  format4: "YYYY-MM-DDTHH:mm:ss", // custom time format for localTS specifically
  format5: "ddd, MMM DD", // eg. "Mon, Sep 07"
  format6: "YYYY-MM-DD",
  format7: "YYYY-MM-DDTHH:mm",
  format8: "YYYY-MM-DDTHH:mm:ss.SSS",
  format9: "MM/DD/YYYY",
};
export const ADMIN = "Admin";
export const SUPER_USER = "Super User";
export const SUPPORT = "Support";


export const timeConfig = {
  format1: "HH:mm:ss", // shows hour minute and seconds
  format2: "HH:mm A", // shows hour minute and AM PM
  format3: "HH:mm", // shows hour minute and seconds
  format4: "hh:mm A",
};

export const barChartData = [
  {
    name: "Bruce Banner",
    transactional: 40,
    nonTransactional: 24,
    total: 64,
  },
  {
    name: "John Appleseed",
    transactional: 30,
    nonTransactional: 13,
    total: 43,
  },
  {
    name: "Ram Mohan",
    transactional: 20,
    nonTransactional: 98,
    total: 118,
  },
  {
    name: "Mark Taylor",
    transactional: 27,
    nonTransactional: 30,
    total: 57,
  },
  {
    name: "Abby Wambach",
    transactional: 18,
    nonTransactional: 40,
    total: 58,
  },
  {
    name: "Carli Lloyd",
    transactional: 23,
    nonTransactional: 23,
    total: 46,
  },
];

export const pieChartData = [
  { name: "Project", value: 411 },
  { name: "Transactional", value: 357 },
  { name: "Non Transactional", value: 47 },
];

export const pieChartColors = {
  Project: "#6DCFF6",
  Transactional: "#1B75BC",
  "Non-Transactional": "#00A88E",
  "Building Moves": "#3C5772",
};

export const stackBarChartData = [
  {
    Name: "CWK RC CS Rep",
    Total: 60.62,
    Project: 30.25,
    "Non-Transactional": 10.02,
  },
  {
    Name: "Art Crate",
    Transactional: 10,
    "Non-Transactional": 10.02,
    Total: 20.02,
  },
  {
    Name: "RC Bus Sprt Spec",
    "Non-Transactional": 40.97,
    Total: 120.97,
    Transactional: 40,
    Project: 40,
  },
  {
    Name: "Outsourced",
    Transactional: 35,
    "Non-Transactional": 45.02,
    Total: 80.02,
  },
  {
    Name: "Art Crate",
    Total: 20.62,
    Project: 32.25,
    Transactional: 60.36,
  },
];

export const durationOptions = [8, 10, 12];
export const defaultSelection = "-1";

export const languageCodes = {
  english: "en",
  spanish: "es",
  portuguese: "pt",
  german: "de",
  dutch: "nl",
  french: "fr",
  turkish: "tr",
  romanian: "ro",
  greek: "el",
  russian: "ru",
  thai: "th",
  slovak: "sk",
  indonesian: "id",
  serbian: "bs",
  bulgarian: "bg",
  polish: "pl",
  taiwan: "zhtw",
  chineseSimplified: "zhcn",
  korean: "ko",
};

export const empIDMaxLength = 12;
export const numericRegex = /^[0-9]*$/;
export const downloadFileNameAllPunch = "All_Activities.csv";
export const add = "add";
export const edit = "edit";
export const activityType = {
  new: "new",
  edit: "edit",
};

export const defaultPaginationOptions = [5, 10, 25, 100];

export const defaultRowsPerPage = 25;

export const getTextLabels = (t) => {
  return {
    body: {
      noMatch: t("other.noMatch"),
      toolTip: t("other.toolTip"),
      columnHeaderTooltip: (column) =>
        t("other.columnHeaderTooltip") + " " + column.label,
      // `t("other.columnHeaderTooltip") ${column.label}`,
    },
    pagination: {
      next: t("other.tblNextPage"),
      previous: t("other.tblPreviousPage"),
      rowsPerPage: t("other.tblRowsPerPage"),
      displayRows: t("other.tblDisplayRows"),
    },
    toolbar: {
      search: t("other.tblSearch"),
      downloadCsv: t("other.tblDownload"),
      print: t("other.tblPrint"),
      viewColumns: t("other.tblViewCol"),
      filterTable: t("other.tblFilter"),
    },
    filter: {
      all: t("other.tblAll"),
      title: t("other.tblFilters"),
      reset: t("other.tblReset"),
    },
    viewColumns: {
      title: t("other.tblShowCol"),
      titleAria: t("other.tblShowHideCol"),
    },
    selectedRows: {
      text: t("other.tblRowsSelected"),
      delete: t("other.tblDel"),
      deleteAria: t("other.tblDelSelectedRow"),
    },
  };
};

export const jobFamilyCamelCase = {
  dsSpec: "DS Spec",
  outsourced: "Outsourced",
  rcBusSprtSpec: "RC Bus Sprt Spec",
  rcCsRep: "RC CS Rep",
  rcDeSpec: "RC DE Spec",
  rcMaint: "RC Maint",
  rcManager: "RC Manager",
  rcSpec: "RC Spec",
  roiSpec: "ROI Spec",
  sitad: "SITAD",
  sales: "Sales",
  shredMaint: "Shred Maint",
  shredSpec: "Shred Spec",
  transDataMgt: "Trans Data Mgt",
  transRim: "Trans RIM",
  transShred: "Trans Shred",
  vaultSpec: "Vault Spec",
  wdc: "WDC",
};

export const activityGroupCamelCase = {
  buildingMoves: "Building Moves",
  leave: "Leave",
  meal: "Meal",
  nonTransactional: "Non-Transactional",
  project: "Project",
  transactional: "Transactional",
};


export const DISTRICT_ID = "districtId";
export const START_DATE = "weekStartDate";
export const PRIMARY_BUILDING = "primaryBuilding";

export const batchSize = 400;

export const acivityIds = {
    "boxDestruction" : 68 ,
    "boxRetrievalRush": 27 ,
    "boxRetrieval": 23,
    "fileRetrievalRush":33,
    "fileRetrieval": 32 ,
    "filePutaway": 12,
    "fileDestructionRush" : 79 ,
    "fileDestruction" : 77,
    "boxPutaway" : 11,
    "boxListPutaway": 11 ,
    "fileListPutaway": 12,
    "reboxOnestep": 112,
    "reboxProcessing": 112,
    "reboxCandidate": 111,
    "reboxActual":112
  };

export const activitiesInOrder = [
  "Shelf Consolidation",
  "Open Shelf File PALM",
  "Box Retrieval Rush",
  "Box Retrieval",
  "File Retrieval Rush",
  "File Retrieval",
  "Box Destruction",
  "File Destruction",
  "File Destruction Rush",
  "File Putaway",
  "File List Putaway",
  "Box Putaway",
  "Box List Putaway",
  "Rebox Actual",
  "Rebox Candidate",
  "Rebox Processing",
  "Rebox Onestep",
  "Shelf Audit",
  "Third Party Tracking",
  "Smart Sort"
]
export const ITContractorExportHeader = 
[
  {key:'Worker_ID',label: 'Worker_ID'},
  {key:'First_Name',label: 'First_Name'},
  {key:'Last_Name',label: 'Last_Name'},
  {key:'Email_Work',label: 'Email_Work'},
  {key:'Manager_ID',label: 'Manager_ID'},
  {key:'Is_Active_Worker', label: 'Is_Active_Worker'},
  {key:'Agency',label: 'Agency'},
  {key:'OtherId',label: 'OtherId'},
  {key:'Phone',label: 'Phone'},
  {key:'Job_Role',label: 'Job_Role'},
  {key:'Country',label: 'Country'},
  {key:'Job_Type',label: 'Job_Type'},
  {key:'Operational_District',label: 'Operational_District'},
  {key:'Operational_Building',label: 'Operational_Building'},
  {key:'Bill_Rate',label: 'Bill_Rate'},
  {key:'Currency',label: 'Currency'},
  {key:'Job_Department',label: 'Job_Department'}
  ]
  
export  const ITContractorFileHeader = [
  'Worker_ID',
  'First_Name',
  'Last_Name',
  'Email_Work',
  'Manager_ID',
  'Is_Active_Worker',
  'Agency',
  'OtherId',
  'Phone',
  'Job_Role',
  'Country',
  'Job_Type',
  'Operational_District',
  'Operational_Building',
  'Bill_Rate',
  'Currency',
  'Job_Department'
  ];
  export const ITContractorTemplate ={
    Worker_ID :  "",
    First_Name :  "First_Name",
    Last_Name : "Last_Name",
    Email_Work :  "test@ironmountain.com",
    Manager_ID :  "12345" ,
    Is_Active_Worker :  "true" ,
    Agency :  "Test Agency" ,
    OtherId :  "1234" ,
    Phone :  "1234567890" ,
    Job_Role :  "RC CS Rep" ,
    Country :  "United States of America" ,
    Job_Type :  "IT Contractor" ,
    Operational_District :  "A-COLLEGEVILLE" ,
    Operational_Building :  "A 01" ,
    Bill_Rate :  "1" ,
    Currency :  "USD" ,
    Job_Department : OPERATIONS

  }
  
export const MB = 1048576;

export const actGrpStackColorMap = {
  buildingMoves: "#3C5772",
  // leave: "Leave",
  // meal: "Meal",
  nonTransactional: "#00A88E",
  project: "#6DCFF6",
  transactional: "#1B75BC",
};

// 🔹 Field definitions
export const inboundFields = [
  { label: "Action TS", value: "actionTS" },
  { label: "Worker Id", value: "workerId" },
  { label: "Worker Name", value: "workerName" },
  { label: "Worker Email", value: "workerEmail" },
  { label: "Worker Country", value: "workerCountry" },
  { label: "Inspection Type", value: "inspectionType" },
  { label: "Building", value: "building" },
  { label: "Customer/Supplier", value: "customer" },
  { label: "Inspection Date", value: "selectedDate" },
  { label: "Unload Start Time", value: "startTime" },
  { label: "Unload End Time", value: "endTime" },
  { label: "Booking Reference", value: "bookingReference" },
  { label: "Vehicle Registration", value: "vehicleRegistration" },
  { label: "Seal Number", value: "sealNumber" },
  { label: "Loading Bay", value: "loadingBay" },
  { label: "Pallets Number", value: "palletsNumber" },
  { label: "SKU Count", value: "skuNumber" },
  { label: "Units Count", value: "units" },
  { label: "Pallets Supplied/Pool Pallets Used", value: "palletsSupplied" },
  { label: "Seals Intact on Arrival", value: "isSealsIntact" },
  { label: "Evidence of Load Compromise", value: "hasProductEvidence" },
  { label: "Product Secured", value: "isProductSecured" },
  { label: "Vehicle Cleanliness", value: "isVehicleClean" },
  { label: "Pest Infestation Evidence", value: "hasPestEvidence" },
  { label: "Contamination/Damage Free", value: "hasProductDamage" },
  { label: "Driver Notes Match Pre-Advice", value: "hasDriversPaperwork" },
  { label: "Packaging Damage", value: "hasPackagingDamage" },
  { label: "Items Clean", value: "isItemsCleaned" },
  { label: "Pallets Free from Damage", value: "hasPalletsDamaged" },
  { label: "Non-Iron Mountain Pallets", value: "hasWrongPallets" },
  { label: "Non-Iron Mountain Pallets Condition", value: "isPalletsQualityOk" },
  { label: "Strong Odours Present", value: "hasOdours" },
  { label: "Temp & Humidity Safe", value: "isTemperatureOk" },
  { label: "Load Refused", value: "isLoadRefused" },
  { label: "Comments", value: "comments" },
  { label: "Doc Id", value: "docId" },
];

export const outboundFields = [
      {label: 'Action TS', value: 'actionTS'},
      {label: 'Worker Id', value: 'workerId'},
      {label: 'Worker Name', value: 'workerName'},
      {label: 'Worker Email', value: 'workerEmail'},
      {label: 'Worker Country', value: 'workerCountry'},
      {label: 'Inspection Type', value: 'inspectionType'},
      {label: 'Building', value: 'building'},
      {label: 'Inspection Date', value: 'selectedDate'},
      {label: 'Load Start Time', value: 'startTime'},
      {label: 'Load End Time', value: 'endTime'},
      {label: 'Vehicle Registration', value: 'vehicleRegistration'},
      {label: 'Seal Number', value: 'sealNumber'},
      {label: 'Loading Bay', value: 'loadingBay'},
      {label: 'Customer/Client', value: 'customer'},
      {label: 'Pallets Loaded Count', value: 'palletsNumber'},
      {label: 'Pallets Picked Count', value: 'palletsPicked'},
      {label: 'Cases Picked Count', value: 'casesPicked'},
      {label: 'Pallets Supplied/Pool Pallets used', value: 'palletsSupplied'},
      {label: 'Pest Infestation Evidence', value: 'hasPestEvidence'},
      {label: 'Evidence of Load Compromise', value: 'hasProductEvidence'},
      {label: 'Vehicle Cleanliness', value: 'isVehicleClean'},
      {label: 'Non-Iron Mountain Pallets', value: 'hasWrongPallets'},
      {label: 'Non-Iron Mountain Pallets Condition', value: 'isPalletsQualityOk'},
      {label: 'Temp & Humidity Safe', value: 'isTemperatureOk'},
      {label: 'Internal Lights Intact', value: 'hasInternalLights'},
      {label: 'Strong Odours Present', value: 'hasOdours'},
      {label: 'Comments', value: 'comments'},
      {label: 'Doc Id', value: 'docId'}
];